import { INVOICE_PAYMENT_STATUS } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const invoicePaymentStatus = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getInvoicePaymentStatus = () => invoicePaymentStatus(
  'get',
  `${INVOICE_PAYMENT_STATUS}?cb=${Date.now()}`,
);

export const createInvoicePaymentStatus = (invoicePaymentStatusName) => invoicePaymentStatus(
  'post',
  INVOICE_PAYMENT_STATUS,
  { payment_status_name: invoicePaymentStatusName },
);

export const updateInvoicePaymentStatus = (
  invoicePaymentStatusId,
  invoicePaymentStatusName,
  isActive,
) => invoicePaymentStatus(
  'put',
  `${INVOICE_PAYMENT_STATUS}/${invoicePaymentStatusId}`,
  {
    payment_status_name: invoicePaymentStatusName,
    is_active: isActive,
  },
);
